import { render, staticRenderFns } from "./TheNewTour.vue?vue&type=template&id=5bcf04f5"
import script from "./TheNewTour.vue?vue&type=script&lang=ts"
export * from "./TheNewTour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsMyLightBox: require('/usr/src/nuxt-app/components/elements/MyLightBox.vue').default})
